export const getCheckboxFilterSearchInputTag = (entityName: string, dataTestIdPrefix = '') =>
  `${dataTestIdPrefix}-checkbox-filter-tile:input-filter-search-${entityName}`;

export const getUnassignedCheckboxFilterItemCheckboxTag = (entityName: string, itemId: string, dataTestIdPrefix = '') =>
  `${dataTestIdPrefix}-checkbox-filter-tile:checkbox-unassigned-filter-${entityName}-item-[${itemId}]`;

export const getAssignedCheckboxFilterItemCheckboxTag = (entityName: string, itemId: string, dataTestIdPrefix = '') =>
  `${dataTestIdPrefix}-checkbox-filter-tile:checkbox-assigned-filter-${entityName}-item-[${itemId}]`;

export const getUnselectAllCheckboxFilterItemsTag = (entityName: string, dataTestIdPrefix = '') =>
  `${dataTestIdPrefix}-checkbox-filter-tile:checkbox-unselect-all-filter-${entityName}-items`;

export const getSeparatorItemTag = (dataTestIdPrefix = '') => `${dataTestIdPrefix}-checkbox-filter-tile:list-separator`;
